module.exports = __webpack_public_path__ + "static/img/Frame24.58429293.png";